module.exports = __webpack_public_path__ + "img/block-3.80d657f7.png";